import { handleImagenSeleccionada } from "../../../shared/utils/funciones";

interface CompaniaFormLogosProps {
    register: any;
    errors: any;
    logo_primario_guardado?: string;
    logoPrincipalBase64?: string | null;
    setLogoPrincipalBase64?: (v: any) => void;
    logo_secundario_guardado?: string;
    logoSecundarioBase64?: string | null;
    setLogoSecundarioBase64?: (v: any) => void;
}

export const CompaniaFormLogos = ({
    register,
    errors,
    logo_primario_guardado,
    logoPrincipalBase64,
    setLogoPrincipalBase64,
    logo_secundario_guardado,
    logoSecundarioBase64,
    setLogoSecundarioBase64,
}: CompaniaFormLogosProps) => {
    return (
        <>
            <hr className="mt-3" />
            <h4 className="px-2">Configuración del sistema</h4>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-top">
                    <label className="col-4 col-lg-4 text-start px-2">Logo principal</label>
                    <div className="col-lg-8">
                        <div className="input-group mb-3">
                            <input
                                {...register("imagen_logo_principal", {
                                    validate: (value) => {
                                        // Verificar si se seleccionó un archivo
                                        if (!value[0]) return true;
                                        // Verificar si el archivo es una imagen
                                        return value[0].type.startsWith("image/");
                                    },
                                })}
                                type="file"
                                className="form-control form-control-sm"
                                id="inputGroupFile01"
                                accept="image/*"
                                onChange={(e) => handleImagenSeleccionada(e, setLogoPrincipalBase64)}
                            />
                        </div>
                    </div>
                </div>
                {
                    (logo_primario_guardado !== "" || logoPrincipalBase64 != null) && (
                        <div className="col-lg-8 mx-auto d-flex justify-content-center align-items-center" style={{ height: "190px", width: "190px" }}>
                            <img
                                src={logoPrincipalBase64 || logo_primario_guardado}
                                alt="Imagen logo 1"
                                className="img-thumbnail"
                            />
                        </div>
                    )}
                {errors.imagen_logo_principal && (
                    <p role="alert" className="error px-2 mb-0">
                        {errors.imagen_logo_principal.type === 'validate' ? 'Debe seleccionar una imagen válida' : ''}
                    </p>
                )}
            </div>
            <div className="col-12 col-lg-6">
                <div className="d-flex align-items-top">
                    <label className="col-4 col-lg-4 text-start px-2">Logo secundario</label>
                    <div className="col-lg-8">
                        <div className="input-group mb-3">
                            <input
                                {...register("imagen_logo_secundario", {
                                    validate: (value) => {
                                        // Verificar si se seleccionó un archivo
                                        if (!value[0]) return true;
                                        // Verificar si el archivo es una imagen
                                        return value[0].type.startsWith("image/");
                                    },
                                })}
                                type="file"
                                className="form-control form-control-sm"
                                id="inputGroupFile02"
                                accept="image/*"
                                onChange={(e) => handleImagenSeleccionada(e, setLogoSecundarioBase64)}
                            />
                        </div>
                    </div>
                </div>
                {
                    (logo_secundario_guardado !== "" || logoSecundarioBase64 != null) && (
                        <div className="col-lg-8 mx-auto d-flex justify-content-center align-items-center" style={{ height: "190px", width: "190px" }}>
                            <img
                                src={logoSecundarioBase64 || logo_secundario_guardado}
                                alt="Imagen logo 2"
                                className="img-thumbnail"
                            />
                        </div>
                    )
                }

                {errors.imagen_logo_secundario && (
                    <p role="alert" className="error px-2 mb-0">
                        {errors.imagen_logo_secundario.type === 'validate' ? 'Debe seleccionar una imagen válida' : ''}
                    </p>
                )}
            </div>
        </>
    );
};
